/**
 * Created by torugo on 28/04/2017.
 */
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  }            from "@angular/core";
import { CommonModule }        from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { InstagramComponent }   from './instagram.component';
import {InstagramRoutingModule} from './instagram.routing'
import {RouterModule} from "@angular/router";
import { CalendarComponent } from "./calendar.component";


@NgModule({
    imports : [
        CommonModule,
        ReactiveFormsModule,
        InstagramRoutingModule,
        RouterModule,
    ],
    declarations : [
        CalendarComponent,
        InstagramComponent,
    ],
    providers : [
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class InstagramModule {}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+integrationCode/instagram.module.ts